import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

import LightningIcon from "./assets/lightningIcon.svg";

const FieldUpdateIcon = ({
  tooltip,
  handleClick,
  numberOfUpdates,
  disabled = false,
}: {
  tooltip: string;
  handleClick?: () => void;
  disabled?: boolean;
  numberOfUpdates?: number;
}) => {
  const cursorStyle = useMemo(() => {
    if (disabled) {
      return "now-allowed";
    }

    if (!_.isNil(handleClick)) {
      return "pointer";
    }

    return "initial";
  }, [disabled, handleClick]);

  return (
    <Tooltip title={tooltip} disableInteractive>
      {!_.isNil(numberOfUpdates) ? (
        <Stack
          sx={{
            backgroundColor: colors.blue100,
            cursor: cursorStyle,
          }}
          flexDirection="row"
          borderRadius="10px"
          alignItems="center"
          justifyContent="center"
          gap="2px"
          height="16px"
          width="25px"
          alignSelf="center"
          onClick={!disabled ? handleClick : undefined}
        >
          <img
            src={LightningIcon}
            alt=""
            width="6px"
            height="8px"
            data-testid="field-updated-icon"
          />
          <Text
            sx={{
              color: colors.white,
              fontSize: 10,
              fontWeight: 600,
            }}
          >
            {numberOfUpdates}
          </Text>
        </Stack>
      ) : (
        <Stack
          sx={{
            backgroundColor: colors.blue100,
          }}
          borderRadius="10px"
          alignItems="center"
          justifyContent="center"
          height="16px"
          width="16px"
        >
          <img
            src={LightningIcon}
            alt=""
            width="6px"
            height="8px"
            onClick={!disabled ? handleClick : undefined}
            data-testid="field-updated-icon"
            style={{ cursor: cursorStyle }}
          />
        </Stack>
      )}
    </Tooltip>
  );
};
export default FieldUpdateIcon;
